export default __webpack_public_path__ + "static/media/Wortmarke_Stern_mobil.0c65d7df.svg";